import React from 'react';
import { 
  Instagram, 
  Youtube, 
  Facebook, 
  Linkedin, 
  Twitter, 
  Send, 
  Github, 
  Music, 
  Globe, 
  Link as LinkIcon, 
  Video, 
  Radio, 
  Phone, 
  Mail, 
  Share2, 
  Sparkles, 
  MessageSquare, 
  MessageCircle, 
  Headphones, 
  Film, 
  Tv, 
  Rss,
  ExternalLink,
  Flame,
  Star,
  Layers,
  Heart
} from 'lucide-react';
import { SiteSettings, SocialLinkItem } from '../../types';

// Official SVG Icons for WhatsApp, TikTok, and X
export const WhatsappSvgIcon = ({ size = 20, className = "" }: { size?: number; className?: string }) => (
  <svg width={size} height={size} viewBox="0 0 448 512" fill="currentColor" xmlns="http://www.w3.org/2000/svg" className={className}>
    <path d="M380.9 97.1C339 55.1 283.2 32 223.9 32c-122.4 0-222 99.6-222 222 0 39.1 10.2 77.3 29.6 111L0 480l117.7-30.9c32.4 17.7 68.9 27 106.1 27h.1c122.3 0 224.1-99.6 224.1-222 0-59.3-25.2-115-67.1-157zm-157 341.6c-33.2 0-65.7-8.9-94-25.7l-6.7-4-69.8 18.3L72 359.2l-4.4-7c-18.5-29.4-28.2-63.3-28.2-98.2 0-101.7 82.8-184.5 184.6-184.5 49.3 0 95.6 19.2 130.4 54.1 34.8 34.9 56.2 81.2 56.1 130.5 0 101.8-84.9 184.6-186.6 184.6zm101.2-138.2c-5.5-2.8-32.8-16.2-37.9-18-5.1-1.9-8.8-2.8-12.5 2.8-3.7 5.6-14.3 18-17.6 21.8-3.2 3.7-6.5 4.2-12 1.4-5.5-2.8-23.4-8.6-44.6-27.5-16.4-14.7-27.5-32.8-30.7-38.3-3.2-5.6-.3-8.6 2.5-11.4 2.5-2.5 5.5-6.5 8.3-9.7 2.8-3.3 3.7-5.5 5.5-9.3 1.9-3.7.9-6.9-.5-9.7-1.4-2.8-12.5-30.1-17.1-41.2-4.5-10.8-9.1-9.3-12.5-9.5-3.2-.2-6.9-.2-10.6-.2-3.7 0-9.7 1.4-14.8 6.9-5.1 5.6-19.4 19-19.4 46.3 0 27.3 19.9 53.7 22.6 57.4 2.8 3.7 39.1 59.7 94.8 83.8 13.2 5.8 23.5 9.2 31.5 11.8 13.3 4.2 25.4 3.6 35 2.2 10.7-1.6 32.8-13.4 37.4-26.4 4.6-13 4.6-24.1 3.2-26.4-1.3-2.5-5-3.9-10.5-6.6z"/>
  </svg>
);

export const TikTokSvgIcon = ({ size = 20, className = "" }: { size?: number; className?: string }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="currentColor" xmlns="http://www.w3.org/2000/svg" className={className}>
    <path d="M12.525.02c1.31-.02 2.61-.01 3.91-.02.08 1.53.63 3.09 1.75 4.17 1.12 1.11 2.7 1.62 4.24 1.79v4.03c-1.44-.05-2.89-.35-4.2-.97-.57-.26-1.1-.59-1.62-.97-.01 2.92.01 5.84-.02 8.75-.08 1.4-.54 2.79-1.35 3.94-1.31 1.92-3.58 3.17-5.91 3.21-1.43.08-2.86-.31-4.08-1.03-2.02-1.19-3.44-3.37-3.65-5.71-.02-.5-.03-1-.01-1.49.18-1.9 1.12-3.72 2.58-4.96 1.66-1.44 3.98-2.13 6.15-1.72.02 1.48-.04 2.96-.04 4.44-.99-.32-2.15-.23-3.02.37-.63.41-1.11 1.04-1.36 1.75-.21.51-.24 1.07-.14 1.61.24 1.64 1.82 3.02 3.5 2.87 1.12-.01 2.19-.66 2.77-1.61.19-.33.4-.67.41-1.06.1-1.79.06-3.57.07-5.36.01-4.03-.01-8.05.02-12.07z"/>
  </svg>
);

export const XSvgIcon = ({ size = 18, className = "" }: { size?: number; className?: string }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="currentColor" xmlns="http://www.w3.org/2000/svg" className={className}>
    <path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-5.214-6.817L4.99 21.75H1.68l7.73-8.835L1.254 2.25H8.08l4.713 6.231zm-1.161 17.52h1.833L7.084 4.126H5.117z"/>
  </svg>
);

export const TelegramSvgIcon = ({ size = 20, className = "" }: { size?: number; className?: string }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="currentColor" xmlns="http://www.w3.org/2000/svg" className={className}>
    <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm4.64 6.8c-.15 1.58-.8 5.42-1.13 7.19-.14.75-.42 1-.68 1.03-.58.05-1.02-.38-1.58-.75-.88-.58-1.38-.94-2.23-1.5-.99-.65-.35-1.01.22-1.59.15-.15 2.71-2.48 2.76-2.69a.2.2 0 00-.05-.18c-.06-.05-.14-.03-.21-.02-.09.02-1.49.95-4.22 2.79-.4.27-.76.41-1.08.4-.36-.01-1.04-.2-1.55-.37-.63-.2-1.12-.31-1.08-.66.02-.18.27-.36.75-.55 2.92-1.27 4.86-2.11 5.83-2.51 2.78-1.16 3.35-1.36 3.73-1.36.08 0 .27.02.39.12.1.08.13.19.14.27-.01.06.01.24 0 .38z"/>
  </svg>
);

export const ThreadsSvgIcon = ({ size = 20, className = "" }: { size?: number; className?: string }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="currentColor" xmlns="http://www.w3.org/2000/svg" className={className}>
    <path d="M12 2.5a9.5 9.5 0 0 0-9.5 9.5c0 4.7 3.4 8.6 7.9 9.3v-2.1a7.4 7.4 0 0 1-5.8-7.2c0-4.1 3.3-7.4 7.4-7.4s7.4 3.3 7.4 7.4c0 3.2-2.1 5.6-5.1 5.6-1.5 0-2.8-.7-3.4-1.8l1.7-1c.4.7 1 1 1.7 1 1.8 0 3-1.5 3-3.8 0-2.5-1.9-4.3-4.5-4.3-2.8 0-4.7 2-4.7 4.7 0 2.9 2 4.9 4.8 4.9 1.1 0 2.2-.3 3.1-.9l.9 1.7a8.5 8.5 0 0 1-4 1.1c-3.9 0-6.8-2.8-6.8-6.8 0-3.8 2.7-6.7 6.7-6.7 3.8 0 6.5 2.6 6.5 6.3 0 4.3-3 7.6-7.1 7.6-1.8 0-3.4-.6-4.6-1.8-.7-.7-1.2-1.6-1.5-2.6A9.5 9.5 0 0 0 12 2.5z"/>
  </svg>
);

export const AVAILABLE_ICONS = [
  { id: 'Instagram', name: 'Instagram', component: Instagram, color: 'text-pink-600', hoverBg: 'hover:bg-pink-50 hover:text-pink-600' },
  { id: 'Youtube', name: 'YouTube', component: Youtube, color: 'text-red-600', hoverBg: 'hover:bg-red-50 hover:text-red-600' },
  { id: 'Whatsapp', name: 'WhatsApp', component: WhatsappSvgIcon, color: 'text-emerald-600', hoverBg: 'hover:bg-emerald-50 hover:text-emerald-600' },
  { id: 'Facebook', name: 'Facebook', component: Facebook, color: 'text-blue-600', hoverBg: 'hover:bg-blue-50 hover:text-blue-600' },
  { id: 'Linkedin', name: 'LinkedIn', component: Linkedin, color: 'text-sky-600', hoverBg: 'hover:bg-sky-50 hover:text-sky-600' },
  { id: 'Tiktok', name: 'TikTok', component: TikTokSvgIcon, color: 'text-slate-900', hoverBg: 'hover:bg-slate-100 hover:text-slate-900' },
  { id: 'X', name: 'X (Twitter)', component: XSvgIcon, color: 'text-slate-900', hoverBg: 'hover:bg-slate-100 hover:text-slate-900' },
  { id: 'Telegram', name: 'Telegram', component: TelegramSvgIcon, color: 'text-sky-500', hoverBg: 'hover:bg-sky-50 hover:text-sky-500' },
  { id: 'Threads', name: 'Threads', component: ThreadsSvgIcon, color: 'text-slate-900', hoverBg: 'hover:bg-slate-100 hover:text-slate-900' },
  { id: 'Github', name: 'GitHub', component: Github, color: 'text-slate-800', hoverBg: 'hover:bg-slate-100 hover:text-slate-900' },
  { id: 'Music', name: 'Spotify / Música', component: Music, color: 'text-green-600', hoverBg: 'hover:bg-green-50 hover:text-green-600' },
  { id: 'Globe', name: 'Website / Portal', component: Globe, color: 'text-indigo-600', hoverBg: 'hover:bg-indigo-50 hover:text-indigo-600' },
  { id: 'Link', name: 'Link Externo', component: LinkIcon, color: 'text-purple-600', hoverBg: 'hover:bg-purple-50 hover:text-purple-600' },
  { id: 'MessageCircle', name: 'Chat / Mensagem', component: MessageCircle, color: 'text-teal-600', hoverBg: 'hover:bg-teal-50 hover:text-teal-600' },
  { id: 'Video', name: 'Vídeo / Canal', component: Video, color: 'text-rose-600', hoverBg: 'hover:bg-rose-50 hover:text-rose-600' },
  { id: 'Radio', name: 'Podcast / Rádio', component: Radio, color: 'text-amber-600', hoverBg: 'hover:bg-amber-50 hover:text-amber-600' },
  { id: 'Phone', name: 'Telefone / SAC', component: Phone, color: 'text-blue-500', hoverBg: 'hover:bg-blue-50 hover:text-blue-500' },
  { id: 'Mail', name: 'E-mail / Newsletter', component: Mail, color: 'text-red-500', hoverBg: 'hover:bg-red-50 hover:text-red-500' },
  { id: 'Sparkles', name: 'Especial / VIP', component: Sparkles, color: 'text-amber-500', hoverBg: 'hover:bg-amber-50 hover:text-amber-500' },
  { id: 'Flame', name: 'Tendências / Ofertas', component: Flame, color: 'text-orange-500', hoverBg: 'hover:bg-orange-50 hover:text-orange-500' },
  { id: 'Star', name: 'Favorito / Destaque', component: Star, color: 'text-yellow-500', hoverBg: 'hover:bg-yellow-50 hover:text-yellow-500' },
  { id: 'Heart', name: 'Comunidade / Apoie', component: Heart, color: 'text-rose-500', hoverBg: 'hover:bg-rose-50 hover:text-rose-500' },
];

/**
 * Returns a React element corresponding to icon name or platform
 */
export const renderSocialIcon = (iconNameOrPlatform?: string, size = 24, className = "") => {
  const norm = (iconNameOrPlatform || '').toLowerCase().trim();
  
  if (norm.includes('whatsapp') || norm === 'wa') return <WhatsappSvgIcon size={size} className={className} />;
  if (norm === 'instagram' || norm === 'ig') return <Instagram size={size} className={className} />;
  if (norm.includes('youtube') || norm === 'yt') return <Youtube size={size} className={className} />;
  if (norm === 'facebook' || norm === 'fb') return <Facebook size={size} className={className} />;
  if (norm.includes('linkedin')) return <Linkedin size={size} className={className} />;
  if (norm === 'tiktok') return <TikTokSvgIcon size={size} className={className} />;
  if (norm === 'x' || norm === 'twitter') return <XSvgIcon size={size} className={className} />;
  if (norm === 'telegram' || norm === 'tg') return <TelegramSvgIcon size={size} className={className} />;
  if (norm === 'threads') return <ThreadsSvgIcon size={size} className={className} />;
  if (norm === 'github' || norm === 'git') return <Github size={size} className={className} />;
  if (norm === 'music' || norm === 'spotify') return <Music size={size} className={className} />;
  if (norm === 'globe' || norm === 'website') return <Globe size={size} className={className} />;
  if (norm === 'video' || norm === 'canal') return <Video size={size} className={className} />;
  if (norm === 'radio' || norm === 'podcast') return <Radio size={size} className={className} />;
  if (norm === 'phone' || norm === 'telefone') return <Phone size={size} className={className} />;
  if (norm === 'mail' || norm === 'email') return <Mail size={size} className={className} />;
  if (norm === 'sparkles' || norm === 'vip') return <Sparkles size={size} className={className} />;
  if (norm === 'flame' || norm === 'promo') return <Flame size={size} className={className} />;
  if (norm === 'star') return <Star size={size} className={className} />;
  if (norm === 'heart') return <Heart size={size} className={className} />;
  if (norm === 'message' || norm === 'chat' || norm === 'messagecircle') return <MessageCircle size={size} className={className} />;
  
  // Default to Share2 or LinkIcon
  return <LinkIcon size={size} className={className} />;
};

/**
 * Returns appropriate hover and color classes for a social item
 */
export const getSocialIconHoverClass = (iconNameOrPlatform?: string): string => {
  const norm = (iconNameOrPlatform || '').toLowerCase().trim();
  if (norm.includes('whatsapp') || norm === 'wa') return 'hover:bg-emerald-50 text-gray-500 hover:text-emerald-600 hover:border-emerald-200';
  if (norm === 'instagram' || norm === 'ig') return 'hover:bg-pink-50 text-gray-500 hover:text-pink-600 hover:border-pink-200';
  if (norm.includes('youtube') || norm === 'yt') return 'hover:bg-red-50 text-gray-500 hover:text-red-600 hover:border-red-200';
  if (norm === 'facebook' || norm === 'fb') return 'hover:bg-blue-50 text-gray-500 hover:text-blue-600 hover:border-blue-200';
  if (norm.includes('linkedin')) return 'hover:bg-sky-50 text-gray-500 hover:text-sky-600 hover:border-sky-200';
  if (norm === 'tiktok') return 'hover:bg-slate-100 text-gray-500 hover:text-slate-900 hover:border-slate-300';
  if (norm === 'x' || norm === 'twitter') return 'hover:bg-slate-100 text-gray-500 hover:text-slate-900 hover:border-slate-300';
  if (norm === 'telegram' || norm === 'tg') return 'hover:bg-sky-50 text-gray-500 hover:text-sky-500 hover:border-sky-200';
  if (norm === 'threads') return 'hover:bg-slate-100 text-gray-500 hover:text-slate-900 hover:border-slate-300';
  if (norm === 'github') return 'hover:bg-slate-100 text-gray-500 hover:text-slate-900 hover:border-slate-300';
  if (norm === 'music' || norm === 'spotify') return 'hover:bg-green-50 text-gray-500 hover:text-green-600 hover:border-green-200';
  if (norm === 'globe' || norm === 'website') return 'hover:bg-indigo-50 text-gray-500 hover:text-indigo-600 hover:border-indigo-200';
  if (norm === 'video') return 'hover:bg-rose-50 text-gray-500 hover:text-rose-600 hover:border-rose-200';
  if (norm === 'sparkles') return 'hover:bg-amber-50 text-gray-500 hover:text-amber-600 hover:border-amber-200';
  return 'hover:bg-primary/10 text-gray-500 hover:text-primary hover:border-primary/30';
};

/**
 * Extracts and compiles all active social media links from SiteSettings
 */
export const getActiveSocialLinks = (settings: SiteSettings): SocialLinkItem[] => {
  // If explicitly defined structured socialLinks exist
  if (Array.isArray(settings.socialLinks) && settings.socialLinks.length > 0) {
    return settings.socialLinks.filter(item => item.enabled !== false && item.url && item.url.trim() !== '');
  }

  // Fallback: build default array from individual settings properties
  const links: SocialLinkItem[] = [];

  if (settings.whatsappNumber) {
    const cleanNumber = settings.whatsappNumber.replace(/\D/g, '');
    if (cleanNumber) {
      links.push({
        id: 'whatsapp',
        platform: 'whatsapp',
        label: 'WhatsApp',
        url: `https://wa.me/${cleanNumber}`,
        icon: 'Whatsapp',
        enabled: true
      });
    }
  }

  if (settings.instagramUrl) {
    links.push({
      id: 'instagram',
      platform: 'instagram',
      label: 'Instagram',
      url: settings.instagramUrl,
      icon: 'Instagram',
      enabled: true
    });
  }

  if (settings.youtubeUrl) {
    links.push({
      id: 'youtube',
      platform: 'youtube',
      label: 'YouTube',
      url: settings.youtubeUrl,
      icon: 'Youtube',
      enabled: true
    });
  }

  if (settings.facebookUrl) {
    links.push({
      id: 'facebook',
      platform: 'facebook',
      label: 'Facebook',
      url: settings.facebookUrl,
      icon: 'Facebook',
      enabled: true
    });
  }

  if (settings.linkedInUrl) {
    links.push({
      id: 'linkedin',
      platform: 'linkedin',
      label: 'LinkedIn',
      url: settings.linkedInUrl,
      icon: 'Linkedin',
      enabled: true
    });
  }

  if (settings.tiktokUrl) {
    links.push({
      id: 'tiktok',
      platform: 'tiktok',
      label: 'TikTok',
      url: settings.tiktokUrl,
      icon: 'Tiktok',
      enabled: true
    });
  }

  if (settings.xUrl) {
    links.push({
      id: 'x',
      platform: 'x',
      label: 'X (Twitter)',
      url: settings.xUrl,
      icon: 'X',
      enabled: true
    });
  }

  if (settings.telegramUrl) {
    links.push({
      id: 'telegram',
      platform: 'telegram',
      label: 'Telegram',
      url: settings.telegramUrl,
      icon: 'Telegram',
      enabled: true
    });
  }

  if (settings.threadsUrl) {
    links.push({
      id: 'threads',
      platform: 'threads',
      label: 'Threads',
      url: settings.threadsUrl,
      icon: 'Threads',
      enabled: true
    });
  }

  if (settings.githubUrl) {
    links.push({
      id: 'github',
      platform: 'github',
      label: 'GitHub',
      url: settings.githubUrl,
      icon: 'Github',
      enabled: true
    });
  }

  if (settings.spotifyUrl) {
    links.push({
      id: 'spotify',
      platform: 'spotify',
      label: 'Spotify',
      url: settings.spotifyUrl,
      icon: 'Music',
      enabled: true
    });
  }

  return links;
};
